var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-between"},[_c('div',{staticClass:"login-image"},[_c('img',{attrs:{"src":_vm.logo,"alt":"Image Profile"}}),_c('div',{staticClass:"caption"},[_c('h5',[_vm._v(_vm._s(_vm.$t("welcomeInTurbo")))]),_c('p',[_vm._v(_vm._s(_vm.$t("theLargestShipping")))])])]),_c('router-view',{staticClass:"parent-login"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }